import EntryIndex from '@component/EntryIndex';
// import Divider from '@componentPrimitives/Divider';
import { EventIndexCalendarChip } from './EventIndex.CalendarFilter';

export const EventIndexFilterChips = () => {
  const filterChips = <EntryIndex.CategoryChips display="inline-flex" />;
  const calendarChip = <EventIndexCalendarChip />;
  // const divider = filterChips && calendarChip ? <Divider direction="vertical" margin="xs" /> : null;
  return (
    <>
      {filterChips}
      {/* {divider} */}
      {calendarChip}
    </>
  );
};
